import axios from 'axios'
import Newsletter from '../models/newsletter'
import requestErrorServices from '../services/requestErrorServices'

export default class {
  // Charge la liste des newsletters en fonction du camping
  static loadList (campingId, year) {
    return new Promise((resolve, reject) => {
      axios.get('/api/newsletter/list/' + year + '/' + campingId, null)
        .then(function (response) {
          const newsletters = response.data.newsletters
          const maxAllowed = response.data.maxAllowed
          const tab = []
          for (let i = 0; i < newsletters.length; i++) {
            const news = new Newsletter(newsletters[i])
            tab.push(news)
          }

          var model = {
            newsletters: tab,
            maxAllowed: maxAllowed
          }
          resolve(model)
        })
        .catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // Réserve une Newsletter pour un camping
  static book (campingId, newsletterId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/newsletter/book',
        {
          campingId: campingId,
          newsletterId: newsletterId
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // Annule une Newsletter pour un caming
  static cancel (campingId, newsletterId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/newsletter/cancel',
        {
          campingId: campingId,
          newsletterId: newsletterId
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }
}
